import { render, staticRenderFns } from "./D5.vue?vue&type=template&id=4dc051bd&scoped=true&"
import script from "./D5.vue?vue&type=script&lang=ts&"
export * from "./D5.vue?vue&type=script&lang=ts&"
import style0 from "./D5.vue?vue&type=style&index=0&id=4dc051bd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc051bd",
  null
  
)

export default component.exports